// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-afb5bd72]{color:red}.fb[data-v-afb5bd72]{font-size:4.267vw}.fb[data-v-afb5bd72],.titlebox[data-v-afb5bd72]{font-weight:700}.titlebox[data-v-afb5bd72]{margin-top:2vw}.infobox[data-v-afb5bd72]{line-height:6vw;font-size:3.467vw}", ""]);
// Exports
module.exports = exports;
